import React, { useState } from 'react';
import * as S from './OfferCard.styles';
import Icon from '../../../../../stories/core-components/IconsSelector';
import RadioButton from '../../../../../stories/core-components/CustomRadioButton/CustomRadioButton';
import SignInTags from '../SigninSignupTags/SignInTags';
import { signIn } from './../../../../containers/Common/Utils'
import { pushga } from 'ga-utils';
import { ReviewEvents } from './../../../../config/ga-config';
import GoCash from "../GoCashBanner/GoCashComp";
import { goCashImage, circularGif } from '../../../../config/imageURLs';
import { ctaHelper } from '../../../../utils/ctaHelper'
import { CTA_TYPE, pushOmniEvents } from '../../../../utils/PushEvents/Omniture/utils'
import { pushCtaOmniEvents } from '../../../../utils/PushEvents/Omniture/clickEvents'


const ReviewOfferCard = props => {
  const {
    promos,
    onPromoSelect,
    selectedPromoId,
    promoDisplayCount,
    onManualPromoClick,
    goCash,
    isGocashSelected,
    onGoCashToggle,
    manualPromoError,
    isLoggedIn,
    promo_applied,
    onPromoRemove,
    offerAction,
    redDeal
  } = props;
  const [showAllPromo, togglePromo] = useState(false);
  const [manualPromoValue, setManualPromoValue] = useState('');

  const nitroPromoCode = redDeal?.is_nitro ? redDeal?.promo_code : '';
  const nitroSubTitle = redDeal?.is_nitro ? redDeal?.sub_title : '';
  // const nitroOfferExists = redDeal?.offer_exists === false ? false : true;

  return (
    <S.OfferWrap>
      {!isLoggedIn ? <S.SignInTagsWrap>
        <SignInTags imgsrc={goCashImage} tagText='Login to use your goCash ' onClick={(evt) => {
          pushCtaOmniEvents('Login_banner_selected',CTA_TYPE.HYPER_LINK, 'GoCash Login', 'Home');
          evt.stopPropagation();
          signIn();
        }} />
      </S.SignInTagsWrap> : <></>}

      {/* {goCash && goCash.is_gocash_applicable && isLoggedIn ?
        <GoCash
          goCash={goCash}
          isGocashSelected={isGocashSelected}
          onGoCashToggle={onGoCashToggle}
        /> : <></>} */}

      {redDeal && redDeal?.title && redDeal?.sub_title && redDeal?.pre_applied_text ?
        <S.OfferBox key={redDeal.title}>
          <S.OfferBoxHdr>
            <Icon name='OffersIcon' styleProps={{ fill: '#FAA243' }} />
            <S.HdrTxt>{redDeal.title}</S.HdrTxt>
            <S.AppliedTag>
              <span>{redDeal.pre_applied_text}</span>
            </S.AppliedTag>
          </S.OfferBoxHdr>
          <S.OfferBoxContent><S.OfferTxt textColor={redDeal.sub_color}>{redDeal.sub_title}</S.OfferTxt></S.OfferBoxContent>
        </S.OfferBox> : <></>}


      {promos && promos.length ? promos.map((promo, index) => {
        const { key, value, chunk_key } = promo;
        if (showAllPromo || index < promoDisplayCount) {
          const isSelectedPromo = promo_applied && promo_applied.success && selectedPromoId.toLowerCase() === key.toLowerCase()
          return (
            <S.OfferBox key={chunk_key}>
              <S.OfferBoxHdr>
                <RadioButton
                  label={key}
                  id={key}
                  checked={selectedPromoId.toLowerCase() === key.toLowerCase()}
                  onChangeCB={id => {
                    if (selectedPromoId.toLowerCase() !== promo.key.toLowerCase()) {
                      onPromoSelect(promo);
                    }
                  }}
                />
                {isSelectedPromo ? <S.AppliedTag onClick={() => { onPromoRemove() }}>
                  <span>APPLIED</span>
                  <S.CloseIcon>x</S.CloseIcon>
                </S.AppliedTag> 
                : null}
                {offerAction && offerAction.isPromo && offerAction.promoName.toLowerCase() === key.toLowerCase() ? <S.TagLoader>
                  <img src={circularGif} />
                  <span>APPLYING</span>
                </S.TagLoader> : null}
              </S.OfferBoxHdr>
              <S.OfferBoxContent>
                {isSelectedPromo ?
                  <S.OfferTxt>{promo_applied.promomessage}</S.OfferTxt>
                  : <S.OfferTxt>{value}</S.OfferTxt>}
                {false ? <S.KnowMoreLink>Know More</S.KnowMoreLink> : null}
                {key === nitroPromoCode && nitroSubTitle ? <S.ImpInfoMsg>{nitroSubTitle}</S.ImpInfoMsg> : <></>}
              </S.OfferBoxContent>
            </S.OfferBox>
          );
        }
      }) : null}

      <S.OfferBox>
        <S.OfferBoxHdr>
          <Icon name='OffersIcon' />
          <S.HdrTxt>ENTER PROMO CODE </S.HdrTxt>
        </S.OfferBoxHdr>
        <S.OfferBoxContent>
          <S.TextBoxWrap>
            <S.TextBox
              type="text"
              className={manualPromoError ? "error" : ""}
              placeholder="Got A Promocode? Enter"
              value={manualPromoValue}
              onChange={evt => {
                setManualPromoValue(evt.target.value);
              }}
            ></S.TextBox>
            <S.TextBoxArrowWrap title="Apply promo"
              onClick={() => {
                if (manualPromoValue) {
                  onManualPromoClick(manualPromoValue, true);
                }
              }}
            >
              <Icon name="ArrowRight" />
            </S.TextBoxArrowWrap>
          </S.TextBoxWrap>
          {(promo_applied?.offer_key?.toLowerCase() === manualPromoValue?.toLowerCase() ||
           promo_applied?.promoname?.toLowerCase()  === manualPromoValue?.toLowerCase()) 
           && <S.OfferTxt>{promo_applied.promomessage}</S.OfferTxt>}
          {manualPromoError ?
            <S.ErrorTxt>{manualPromoError}</S.ErrorTxt> : null}
        </S.OfferBoxContent>
      </S.OfferBox>

      {promos && promos.length && promos.length > promoDisplayCount ?
        <S.PromoLink
          onClick={evt => {
            evt.preventDefault();
            togglePromo(!showAllPromo);
            pushga({
              event: ReviewEvents.actions.view_all_promo,
              eventCategory: ReviewEvents.category,
              eventAction: ReviewEvents.actions.view_all_promo,
            });
          }}>
          <a href="#">{`${showAllPromo ? 'Show less' : ' View all'} promocodes`}</a>
        </S.PromoLink> : null}
    </S.OfferWrap>
  );
};

export default ReviewOfferCard;
